import { useNavigate } from "react-router-dom";

import { useAuthenticator } from "@aws-amplify/ui-react";
import "@aws-amplify/ui-react/styles.css";

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Container,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import { getChurchId, isAdmin } from "../../utils/helper";
import { LoginWindow } from "../../components/LoginWindow";
import TopNavBar from "../../components/TopNavBar";
import { useUserData } from "../../components/DataProvider";

const styles = {
  navBar: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    mb: 5,
  },
  innerBox: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    mt: 2,
    mb: 4,
    pt: 2,
    pb: 2,
    border: 1,
    borderColor: "#D6E4FF",
    borderRadius: 2,
  },
  actionButton: {
    height: 60,
    width: 300,
    backgroundColor: "#00169E",
    color: "#FFF",
    fontSize: 16,
  },
};

const AdminPage = () => {
  const navigate = useNavigate();
  const { attributes } = useUserData();
  const theme = useTheme();
  const isLargeScreen = useMediaQuery(theme.breakpoints.up("md"));
  const { authStatus } = useAuthenticator((context) => [context.authStatus]);

  const subtitle = isAdmin(attributes)
    ? `${getChurchId(attributes)}: ${attributes.given_name} ${attributes.family_name}`
    : "Hello Visitor";
  return authStatus === "authenticated" && isAdmin(attributes) ? (
    <div>
      <Container maxWidth={isLargeScreen ? "md" : false}>
        <Box
          sx={[{ "& .MuiTextField-root": { m: 1 } }, styles.navBar]}
          component="form"
          noValidate
          autoComplete="off"
          maxWidth={theme.breakpoints.values.md}
        >
          <TopNavBar showBackArrow={false} />
          <Box sx={styles.innerBox} minWidth={theme.breakpoints.values.sm}>
            <Typography variant={"h6"}>{subtitle}</Typography>
          </Box>
          <Stack direction="column" spacing={3}>
            <Button
              onClick={() => {
                navigate("/admin/invite_church");
              }}
              variant="outlined"
              style={styles.actionButton}
            >
              Invite Church
            </Button>
            <Button
              onClick={() => {
                navigate("/admin/invitations");
              }}
              variant="outlined"
              style={styles.actionButton}
            >
              Manage Invitations
            </Button>
            <Button
              onClick={() => {
                navigate("/admin/dashboard");
              }}
              variant="outlined"
              style={styles.actionButton}
            >
              View Dashboard
            </Button>
            <Button
              onClick={() => {
                navigate("/admin/overview");
              }}
              variant="outlined"
              style={styles.actionButton}
            >
              Baptize America Overview
            </Button>
            <Button
              onClick={() => {
                navigate("/admin/users");
              }}
              variant="outlined"
              style={styles.actionButton}
            >
              Display Users
            </Button>
          </Stack>
          <Box>
            <Accordion sx={{ m: "1rem" }}>
              <AccordionSummary
                expandIcon={<ArrowDownwardIcon />}
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <Typography component="span">Dangerous Actions</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "1rem",
                    flexWrap: "wrap",
                    width: "100%",
                  }}
                >
                  <Button
                    onClick={() => {
                      navigate("/admin/create_admin");
                    }}
                    style={{
                      ...styles.actionButton,
                      color: "#fff",
                      backgroundColor: "#9e0000",
                    }}
                  >
                    Create Admin User
                  </Button>
                  <Button
                    onClick={() => {
                      navigate("/admin/delete_user");
                    }}
                    style={{
                      ...styles.actionButton,
                      color: "#fff",
                      backgroundColor: "#9e0000",
                    }}
                  >
                    Delete User
                  </Button>
                </div>
              </AccordionDetails>
            </Accordion>
          </Box>
        </Box>
      </Container>
    </div>
  ) : (
    <LoginWindow />
  );
};

export default AdminPage;
